<template>
  <div class="footer-m-container">
    <div v-if="false" class="footer-detail">
      <div class="rights">
        <p>
          <a href="http://www.fahorro.com/terminos-y-condiciones/" target="_blank">{{ $t('general.terms') }}</a>
        </p>
      </div>
      <div class="privacy">
        <p>
          <a href="http://www.fahorro.com/aviso-de-privacidad/" target="_blank">{{ $t('general.privacy') }}</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  data: function() {
    return {
      product: process.env.VUE_APP_PRODUCT,
      business: process.env.VUE_APP_BUSINESS
    }
  },
  computed: {
    poweredBy() {
      return `2019 ${this.product} ${this.$t('general.poweredBy')}`
    }
  }
}
</script>
